export const OPEN_NOW_SHIPPING_MODAL = 'open-now-shipping-modal'
